export const VIEWER_EMBED_SUBJECTS = [
    'EmbedDashboardFilters',
    'EmbedDashboardFilterAddition',
    'EmbedDashboardParameters',
    'EmbedCsvExport',
    'EmbedDashboardCsvExport',
    'EmbedImageExport',
    'EmbedPagePdfExport',
    'EmbedDateZoom',
];
export const INTERACTIVE_VIEWER_EMBED_SUBJECTS = [
    'EmbedAiAgent',
    'EmbedAiAgentDebug',
    'EmbedExplore',
    'EmbedUnderlyingData',
    'EmbedDataApps',
];
export const DEVELOPER_EMBED_SUBJECTS = [
    'EmbedCompiledSql',
];
//# sourceMappingURL=types.js.map